import * as React from 'react'
import { Box, Paper, List, ListItem, Input, TextField, Typography, ListItemIcon, ListSubheader, makeStyles, createStyles, Theme, Button } from '@material-ui/core'
import { listCourseForSort, setCourseSort } from '../../utils/api'
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import BookIcon from '@material-ui/icons/Book';
import { useParams } from 'react-router';
import { useFeedback } from '../../components/Feedback';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper,
            position: 'relative',
            overflow: 'auto',
            maxHeight: 300,
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        ul: {
            backgroundColor: 'inherit',
            padding: 0,
        },
    }),
);

const SortCourse = () => {
    const classes = useStyles()
    const { showToast, showLoading, hideLoading } = useFeedback()
    const { courseId }: { [key: string]: string } = useParams()
    const [collections, setCollections] = React.useState<CourseCollection[]>([])
    const [collections1, setCollections1] = React.useState<CourseCollection[]>([])
    const [collections2, setCollections2] = React.useState<CourseCollection[]>([])

    const [changes, setChanges] = React.useState<{
        courseId?: string,
        sort?: number,
        collectionSort?: number,
        collectionId?: string
    }[]>([])

    const [selectedCollection, setSelectedCollection] = React.useState<string | undefined>()
    const [selectedCourse, setSelectedCourse] = React.useState<string>(courseId)
    const loadData = (category?: number) => {
        listCourseForSort(category).then(res => {
            const tmpCollections = [];
            for (let course of res) {
                const [collection] = tmpCollections.filter(c => c.id === course.collection_id)
                if (collection && collection.id) {
                    if (!collection.courses) {
                        collection.courses = []
                    }

                    collection.courses.push(course)
                } else {
                    tmpCollections.push({
                        name: course.collection_name ? course.collection_name : course.name,
                        id: course.collection_id,
                        cover: '',
                        sort: course.collection_sort,
                        create_time: 0,
                        courses: [course],
                        intro: '', details: '', details_raw: '', category: '',
                        lecturer: '', price: 0, original_price: 0
                    })
                }
                if (+course.id === +courseId) {
                    setSelectedCollection(course.collection_id)
                }
            }
            if (category === 1) {
                setCollections1([...tmpCollections])
            } else if (category === 2) {
                setCollections([...tmpCollections])
            } else if (category === 3) {
                setCollections2([...tmpCollections])
            }
        })
    }

    React.useEffect(() => {
        loadData(2)
        loadData(1)
        loadData(3)
    }, [])

    const handleClickCollections = (coll?: CourseCollection, courseIndex?: string) => () => {

        if (coll) {
            if (coll.id) {
                setSelectedCollection(coll.id)
                setSelectedCourse('')
            } else {
                const [course] = coll.courses
                setSelectedCollection(undefined)
                setSelectedCourse(course.id)
            }
        }

        courseIndex && setSelectedCourse(courseIndex)
    }

    const collectionSortChange = (collection: CourseCollection) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const [course] = collection.courses
        if (!course.category) {
            return;
        }
        const colls = chooeseCollections(course.category)
        const index = colls.indexOf(collection)
        collection.sort = parseInt(event.target.value, 10)
        colls[index] = collection
        const sortResult = sortCollections(colls)

        if (+course.category === 1) {
            setCollections1([...sortResult])
        }
        if (+course.category === 2) {
            setCollections([...sortResult])
        }
        if (+course.category === 3) {
            setCollections2([...sortResult])
        }

        if (!collection.id) {
            setChanged(undefined, +event.target.value, course.id)
        } else {
            setChanged(+event.target.value, undefined, undefined, collection.id)
        }
    }

    const chooeseCollections = (category?: string) => {
        if (!category) {
            return []
        }
        if (+category === 1) {
            return collections1
        }
        if (+category === 2) {
            return collections
        }
        if (+category === 3) {
            return collections2
        }
        return []
    }

    const sortCollections = (sorts: CourseCollection[]) => {
        for (let i = 0; i < sorts.length; i++) {
            const sort = sorts[i]
            sort.courses.sort((c, c1) => {
                if (c.sort === c1.sort) {
                    return (c1.create_time ? c1.create_time : 0) - (c.create_time ? c.create_time : 0)
                }
                return (c1.sort ? c1.sort : 0) - (c.sort ? c.sort : 0)
            })
            sorts[i] = sort
        }

        const result = sorts.sort((c, c1) => {
            return c1.sort - c.sort
        })

        return result
    }

    const courseSortChange = (course: Course) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!course.category) {
            return;
        }
        const colls = chooeseCollections(course.category)
        const [sel] = colls.filter(c => c.id === selectedCollection)

        const index = colls.indexOf(sel)
        const cindex = sel.courses.indexOf(course)
        course.sort = parseInt(event.target.value)
        sel.courses[cindex] = course
        colls[index] = sel;

        setChanged(+event.target.value, undefined, course.id)

        const sortResult = sortCollections(colls)
        console.info(+course.category)
        if (+course.category === 1) {
            setCollections1([...sortResult])
        }
        if (+course.category === 2) {
            setCollections([...sortResult])
        }
        if (+course.category === 3) {
            setCollections2([...sortResult])
        }

        // setCourseSort(+event.target.value, undefined, +course.id, undefined).then(res => {
        //     loadData(course.category ? +course.category : 1)
        // })
    }

    const setChanged = (sort?: number, collectionSort?: number, courseId?: string, collectionId?: string) => {
        const [c] = changes.filter(c => {
            if (courseId && courseId === c.courseId) { return true }
            if (collectionId && collectionId === c.collectionId) { return true }
            return false;
        })
        if (c) {
            c.sort = sort
            c.collectionSort = collectionSort
        } else {
            changes.push({ courseId, sort, collectionSort, collectionId })
        }
        setChanges([...changes])
    }

    const CollectionCourse = () => {
        if (!selectedCollection) {
            return <div></div>
        }
        let [collection] = collections.filter(c => c.id === selectedCollection)
        if (!collection) {
            [collection] = collections1.filter(c => c.id === selectedCollection)
        }
        if (!collection) {
            [collection] = collections2.filter(c => c.id === selectedCollection)
        }

        if (!collection || !collection.courses) {
            return <div></div>
        }
        return collection.courses.map(course => <ListItem onClick={handleClickCollections(undefined, course.id)} key={course.id} button selected={+course.id === (selectedCourse ? +selectedCourse : 0)}>
            <Box display="flex" alignItems="center" >
                <Typography style={{ width: '300px' }} variant="body2">{course.name}</Typography>
                <TextField onChange={courseSortChange(course)} type="number" inputProps={{ style: { textAlign: 'center' } }} size="small" value={course.sort} variant="outlined" style={{ width: '80px', marginLeft: '16px' }} />
            </Box>
        </ListItem>)

    }

    const subList = (name: string, colls: CourseCollection[]) => {
        return <li>
            <ul className={classes.ul}>
                <ListSubheader>
                    {name}
                </ListSubheader>
                {colls.map((c, index) => <ListItem selected={c.id ? c.id === selectedCollection : +c.courses[0].id === +selectedCourse} onClick={handleClickCollections(c)} button key={c.name}>
                    <ListItemIcon>
                        {c.id ? <CollectionsBookmarkIcon /> : <BookIcon />}
                    </ListItemIcon>
                    <Box display="flex" alignItems="center">
                        <Typography style={{ width: '300px' }} variant="body2">{c.name}</Typography>
                        <TextField type="number" onChange={collectionSortChange(c)} inputProps={{ style: { textAlign: 'center' } }} size="small" value={c.sort} variant="outlined" style={{ width: '80px', marginLeft: '16px' }} />
                    </Box>
                    {c.id ? <NavigateNextIcon /> : ''}
                </ListItem>)}
            </ul>
        </li>
    }

    const handleSync = () => {
        let syncs = []
        for (let s of changes) {
            syncs.push(setCourseSort(s.sort, s.collectionSort, s.courseId, s.collectionId))
        }
        showLoading('更新中...,')
        Promise.all(syncs).then(res => {
            hideLoading()
            showToast('更新成功')
        }).catch(e => {
            hideLoading()
            showToast('更新失败')
        })
    }

    return <Box>
        <Button onClick={handleSync}>提交排序更新</Button>
        <Paper style={{ marginTop: '8px' }}>
            <Box display="flex">
                <Box width="500px" borderRight="1px solid #e1e1e1" style={{ height: 'calc( 100vh - 110px )', overflowX: 'scroll' }}>
                    <List subheader={<li />}>
                        {subList('直播回看', collections)}
                        {subList('精品课', collections1)}
                        {subList('大师课', collections2)}
                    </List>
                </Box>
                <Box style={{ height: 'calc( 100vh - 110px )', overflowX: 'scroll' }}>
                    <List>
                        {CollectionCourse()}
                    </List>
                </Box>
            </Box>
        </Paper>
    </Box>
}

export default SortCourse